import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MustMatch } from '@app/_helpers/must-match.validators';
import { UserService } from '@app/_services';
import { faKey, faHome, faPaperPlane, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.css'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {

  changePasswordForm! : FormGroup;
  loading = false;
  submitted = false;
  error = '';
  showPassword = false;
  showConfirmPassword = false;

  faKey = faKey;
  faHome = faHome;
  faPaperPlane = faPaperPlane;
  faEye = faEye;
  faEyeSlash = faEyeSlash;

  passwordPattern = "^[\\S]{5,30}$";

  constructor(private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.changePasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.pattern(this.passwordPattern)]],
      confirmPassword: ['', [Validators.required, Validators.pattern(this.passwordPattern)]]
    }, {
      validators: MustMatch('password', 'confirmPassword')
    });
  }

  cancel() {
    this.router.navigate(['/'])
  }

  get f() { return this.changePasswordForm.controls; }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  onSubmit() {
    this.submitted = true;
    this.loading = true;

    // stop here if form is invalid
    if (this.changePasswordForm.invalid) {

        this.loading = false;
        return;
    }

    var data = this.changePasswordForm.value;

    var request = { password: data.password, token: this.route.snapshot.paramMap.get("token")};

    this.userService.changePassword(request).subscribe(
      data => {
        this.toastr.success(data.message, 'Success');
        this.loading = false;
        setTimeout(() => {
          this.router.navigate(['/'])
        }, 2000);
      },
      error => {
        this.toastr.error(error, 'Error');
        this.loading = false;
      }
    );


  }


}
